import { ProductDetailsModel } from './product-details.model';
export class ReviewOrderProductModel {
    id: string;
    product: string;
    fan: string;
    ban: string;
    ctn: string;
    description: string;
    unitPrice: number;
    initialUnitPrice: number;
    initialLicense: number;
    totalLicense: number;
    modifiedLicense: number;
    initialAmount: number;
    modifiedAmount: number;
    totalAmount: number;
    integerType: string;
    type: string;
    backUrl: string;
    currentProduct: string;
    newProduct: string;
    oneTimeFee: number;
    serviceOfferCode: string;
    subscriptionId: string;
    lineItems: Array<ProductDetailsModel>;
    estimatedDiscount: number;
    unitTotalAmount: number;
    oneTimeFeeInfo: number;
    oneTimeFeeEstimatedDiscount: number;
}
